import { HourlyTuitionDiscountType } from '~entities/payment/api/hourly-tuition/hourly-tuition.constants';

/**
 * Staff discount sent on hourly post. V2 BE already applies multi-student
 * discount server-side; echoing that same fixed dollar amount as staff doubles it.
 * Percentage staff is never treated as an MSD echo (units differ).
 */
export function resolveStaffDiscountForPost(
  staffDiscountValue: number,
  multiStudentDiscount: number,
  isV2: boolean,
  staffDiscountType: HourlyTuitionDiscountType = HourlyTuitionDiscountType.FIXED,
): number {
  const staff = Number(staffDiscountValue) || 0;
  if (staff <= 0) {
    return 0;
  }
  if (!isV2) {
    return staff;
  }
  if (staffDiscountType !== HourlyTuitionDiscountType.FIXED) {
    return staff;
  }
  const multi = Number(multiStudentDiscount) || 0;
  if (multi > 0 && Math.abs(staff - multi) < 0.005) {
    return 0;
  }
  return staff;
}
